(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rudra-storefront-experience"] && !Shopify.designMode) return;
  try {
    if (!window.RudraStorefrontExperience) {
    window.RudraStorefrontExperience = true;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setScrollState = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.classList.toggle('rudra-scrolled', scrollY > 18);
      document.documentElement.style.setProperty('--rudra-scroll', Math.round(scrollY));
    };

    const setActiveDockItem = () => {
      const path = window.location.pathname;
      document.querySelectorAll('[data-rudra-dock-route]').forEach((item) => {
        const route = item.dataset.rudraDockRoute;
        const isHome = route === '/' && path === '/';
        const isRoute = route !== '/' && path.startsWith(route);
        item.classList.toggle('is-active', isHome || isRoute);
      });
    };

    const initReveals = () => {
      const items = document.querySelectorAll('.card-wrapper.product-card-wrapper, .collection-hero, .product__info-container, .cart-item, .footer-block');
      items.forEach((item) => item.setAttribute('data-rudra-global-reveal', ''));

      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      items.forEach((item) => observer.observe(item));
    };

    const initCardTilt = () => {
      if (prefersReducedMotion || window.matchMedia('(max-width: 989px)').matches) {
        return;
      }

      document.addEventListener('pointermove', (event) => {
        const card = event.target.closest('.card-wrapper.product-card-wrapper');
        if (!card) {
          return;
        }

        const rect = card.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 5;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * -4;
        card.style.setProperty('--rudra-card-tilt-x', `${x}deg`);
        card.style.setProperty('--rudra-card-tilt-y', `${y}deg`);
      });

      document.addEventListener('pointerleave', (event) => {
        const card = event.target.closest('.card-wrapper.product-card-wrapper');
        if (!card) {
          return;
        }

        card.style.removeProperty('--rudra-card-tilt-x');
        card.style.removeProperty('--rudra-card-tilt-y');
      }, true);
    };

    document.addEventListener('DOMContentLoaded', () => {
      setScrollState();
      setActiveDockItem();
      initReveals();
      initCardTilt();
    });

    document.addEventListener('shopify:section:load', () => {
      initReveals();
      setActiveDockItem();
    });

    window.addEventListener('scroll', setScrollState, { passive: true });
    setScrollState();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rudra-whatsapp-cart-button"] && !Shopify.designMode) return;
  try {
    if (!window.RudraWhatsAppCartButton) {
    window.RudraWhatsAppCartButton = true;

    const buildRudraCartMessage = (cart, button) => {
      const lines = ['Hello Rudra Tiles, I want to enquire about this tile shortlist.'];

      if (!cart.items || cart.items.length === 0) {
        lines.push('I would like to discuss tiles for my project.');
      } else {
        cart.items.forEach((item, index) => {
          const variant = item.variant_title ? ` - ${item.variant_title}` : '';
          lines.push(`${index + 1}. ${item.product_title}${variant}`);
          lines.push(`SKU: ${item.sku || 'To be confirmed'}`);
          lines.push(`Required quantity: ${item.quantity}`);
          if (item.url) {
            lines.push(`Product link: ${window.location.origin}${item.url}`);
          }
        });
      }

      lines.push(button.dataset.cartPrompt || 'Please confirm availability and final quote for this tile shortlist.');
      return lines.join('\n');
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-rudra-cart-whatsapp]');
      if (!button || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      event.preventDefault();

      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await response.json();
        const message = buildRudraCartMessage(cart, button);
        window.location.href = `https://wa.me/${button.dataset.phone}?text=${encodeURIComponent(message)}`;
      } catch (error) {
        window.location.href = button.href;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rudra-whatsapp-product-button"] && !Shopify.designMode) return;
  try {
    if (!window.RudraWhatsAppProductButton) {
    window.RudraWhatsAppProductButton = true;

    class RudraWhatsAppProductButton {
      constructor(button) {
        this.button = button;
        this.scope = button.closest('.card-wrapper') || button.closest('section') || document;
        this.variants = this.getVariants();
        this.update();
      }

      getVariants() {
        const script = this.button.nextElementSibling;
        if (!script || !script.matches('[data-rudra-product-variants]')) {
          return [];
        }

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          return [];
        }
      }

      getVariant() {
        const variantInput = this.scope.querySelector('input.product-variant-id');
        const variantId = variantInput ? variantInput.value : this.button.dataset.productVariantId;

        return this.variants.find((variant) => String(variant.id) === String(variantId));
      }

      update() {
        const variant = this.getVariant();
        const variantTitle = variant ? variant.title : this.button.dataset.productVariantTitle;
        const sku = variant ? variant.sku : this.button.dataset.productSku;
        const variantId = variant ? variant.id : this.button.dataset.productVariantId;
        const quantityInput = this.scope.querySelector('input[name="quantity"], .quantity__input');
        const quantity = quantityInput && Number(quantityInput.value) > 0 ? quantityInput.value : this.button.dataset.productQuantity;
        const productUrl = `${this.button.dataset.productUrl}?variant=${variantId}`;
        const titleParts = [this.button.dataset.productTitle];

        if (this.button.dataset.hasOnlyDefaultVariant !== 'true' && variantTitle) {
          titleParts.push(`- ${variantTitle}`);
        }

        const message = [
          `Hello Rudra Tiles, I want to enquire about ${titleParts.join(' ')}.`,
          `SKU: ${sku || 'To be confirmed'}`,
          `Required quantity: ${quantity || 1}`,
          `Product link: ${productUrl}`,
          this.button.dataset.productPrompt || 'Please confirm availability, suitable sizes, and the project quote.',
        ].join('\n');

        this.button.href = `https://wa.me/${this.button.dataset.phone}?text=${encodeURIComponent(message)}`;
      }
    }

    const initRudraProductButtons = () => {
      document.querySelectorAll('[data-rudra-product-whatsapp]').forEach((button) => {
        button.rudraWhatsAppButton = button.rudraWhatsAppButton || new RudraWhatsAppProductButton(button);
        button.rudraWhatsAppButton.update();
      });
    };

    document.addEventListener('change', (event) => {
      if (event.target.matches('input.product-variant-id, select[name="id"], input[name="id"], input[name="quantity"], .quantity__input')) {
        initRudraProductButtons();
      }
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rudra-product-whatsapp]');
      button?.rudraWhatsAppButton?.update();
    });

    document.addEventListener('DOMContentLoaded', initRudraProductButtons);
    document.addEventListener('shopify:section:load', initRudraProductButtons);
    initRudraProductButtons();
  }
  } catch(e) { console.error(e); }
})();

})();
